export default theme => ({
  negative: { color: "#FF0000" }
});
